import {LocalDateTime} from '@js-joda/core';
import {get} from 'lodash-es';

import {events} from '../events';

export const mySessionsReducer = {
    [events.MY_SESSIONS_GET]: (state = {}) => ({
        ...state,
        isLoading: true
    }),
    [events.MY_SESSIONS_SUCCESS]: (state, {payload: {config, data}}) => {
        if (config.url !== 'api/market-data-session') {
            return ({
                isLoading: false,
                error: false,
                more: get(data, 'meta.more', false),
                rowData: get(data, 'data', []),
                timestamp: LocalDateTime.now()
            });
        } else {
            return ({
                isLoading: false,
                error: false,
                more: get(data, 'meta.more', false),
                timestamp: LocalDateTime.now(),
                rowData: (data?.data || []).map(({pri_rcf, sec_rcf, ...rest})=>({
                    pri_cg: pri_rcf, sec_cg: sec_rcf, ...rest
                }))
            });
        }
    },
    [events.MY_SESSIONS_ERROR]: (state, {error}) => ({
        error,
        isLoading: false,
        more: false,
        rowData: [],
        timestamp: LocalDateTime.now()
    })
};
